<script>
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = ["data-playing", "data-paused", "data-waiting", "data-idle", "data-hover"];
const _hoisted_2 = {
  key: 0,
  class: "magic-player-overlay__button"
};
const _hoisted_3 = {
  key: 0,
  class: "magic-player-overlay__button"
};
const _hoisted_4 = {
  key: 1,
  class: "magic-player-overlay__button"
};
import { inject } from "vue";
import { useIdle } from "@vueuse/core";
import IconPlay from "./icons/Play.vue";
import IconPause from "./icons/Pause.vue";
import IconWaiting from "./icons/Waiting.vue";
import { usePlayerMediaApi } from "../composables/private/usePlayerMediaApi";
import { usePlayerVideoApi } from "../composables/private/usePlayerVideoApi";
import { MagicPlayerInstanceId } from "../symbols";
export default /* @__PURE__ */ _defineComponent({
  __name: "MagicPlayerOverlay",
  setup(__props) {
    const instanceId = inject(MagicPlayerInstanceId, void 0);
    if (!instanceId) {
      throw new Error(
        "MagicPlayerOverlay must be nested inside MagicPlayerProvider."
      );
    }
    const { playing, waiting } = usePlayerMediaApi({
      id: instanceId
    });
    const { mouseEntered, togglePlay } = usePlayerVideoApi({
      id: instanceId
    });
    const { idle } = useIdle(3e3);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "magic-player-overlay",
        "data-playing": _unref(playing),
        "data-paused": !_unref(playing),
        "data-waiting": _unref(waiting),
        "data-idle": _unref(idle),
        "data-hover": _unref(mouseEntered),
        onClick: _cache[0] || (_cache[0] = _withModifiers(
          //@ts-ignore
          (...args) => _unref(togglePlay) && _unref(togglePlay)(...args),
          ["stop"]
        ))
      }, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _unref(waiting) ? (_openBlock(), _createElementBlock("button", _hoisted_2, [
            _renderSlot(_ctx.$slots, "waitingIcon", {}, () => [
              _createVNode(IconWaiting)
            ])
          ])) : (_openBlock(), _createElementBlock(
            _Fragment,
            { key: 1 },
            [
              !_unref(playing) ? (_openBlock(), _createElementBlock("button", _hoisted_3, [
                _renderSlot(_ctx.$slots, "playIcon", {}, () => [
                  _createVNode(IconPlay)
                ])
              ])) : (_openBlock(), _createElementBlock("button", _hoisted_4, [
                _renderSlot(_ctx.$slots, "pauseIcon", {}, () => [
                  _createVNode(IconPause)
                ])
              ]))
            ],
            64
            /* STABLE_FRAGMENT */
          ))
        ])
      ], 8, _hoisted_1);
    };
  }
});
</script>

<style>
.magic-player-overlay {
  position: absolute;
  inset: 0;
  background-color: var(--magic-player-overlay-background, rgba(0, 0, 0, 0.3));
  color: var(--magic-player-overlay-color, rgba(255, 255, 255, 1));
  transition: var(--magic-player-overlay-transition, opacity 300ms ease);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.magic-player-overlay__button {
  background-color: transparent;
  color: inherit;
  border: 0;
  border-radius: 0;
  padding: 0;
  outline: none;
  appearance: none;
  cursor: pointer;
  width: var(--magic-player-overlay-button-size, 2.5rem);
  height: var(--magic-player-overlay-button-size, 2.5rem);
}

.magic-player-overlay[data-playing='true'][data-idle='true'] {
  opacity: 0;
}

.magic-player-overlay[data-playing='true'][data-hover='false'] {
  opacity: 0;
}
</style>
